import { render } from "./BulkOutdatedRegister.vue?vue&type=template&id=fd68dba0"
import script from "./BulkOutdatedRegister.vue?vue&type=script&lang=js"
export * from "./BulkOutdatedRegister.vue?vue&type=script&lang=js"

import "./BulkOutdatedRegister.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__